/**
 * The approved deck's 42 templates (Figma 13 Strategy, Zone plate · APPROVED),
 * by the template a slide names. Each template reads its part of the saved
 * document; every value is marked for the dev label/value mode (kit.tsx).
 */
import type { ComponentType } from "react";
import type { SlideTemplateId } from "../components/strategySlides";
import type { TemplateContext } from "./kit";
import { BriefSlide, CoverSlide, OnePageSlide, OpenerSlide } from "./openingSlides";
import { IndustryChangesSlide, IndustryConventionsSlide, IndustryMixSlide, IndustryNumbersSlide, IndustrySearchesSlide } from "./industrySlides";
import { AudienceSlide, PeopleSlide, PersonaSlide } from "./audienceSlides";
import { AccountSnapshotSlide, CommunitySlide } from "./brandSlides";
import { ComparisonSlide, LessonsSlide, MapSlide, OpenSpaceSlide } from "./competitorSlides";
import { ConversationSlide, MomentOnSocialSlide, MomentsSlide, TrendsSlide } from "./cultureSlides";
import { FindingsSlide, IdeaPostsSlide, IdeaSlide, InsightSlide, MethodSlide } from "./insightSlides";
import { ObjectivesSlide, TargetsSlide } from "./goalsSlides";
import { PlatformsSlide } from "./platformSlides";
import { CodesSlide, MixSlide, PillarSlide, PillarsSlide } from "./contentSlides";
import { RhythmSlide, YearSlide } from "./yearSlides";
import { CreatorsSlide } from "./creatorsSlides";
import { ReadingSlide, TestsSlide } from "./measuringSlides";
import { CloseSlide, HowSlide, SourcesSlide } from "./recordSlides";
import "./strategyDeck.css";

export type { TemplateContext } from "./kit";

/** Every template the deck names; a template missing here fails the type check. */
const TEMPLATES: Record<SlideTemplateId, ComponentType<{ ctx: TemplateContext }>> = {
  cover: CoverSlide,
  opener: OpenerSlide,
  onepage: OnePageSlide,
  brief: BriefSlide,
  "industry-numbers": IndustryNumbersSlide,
  "industry-changes": IndustryChangesSlide,
  "industry-searches": IndustrySearchesSlide,
  "industry-mix": IndustryMixSlide,
  "industry-conventions": IndustryConventionsSlide,
  audience: AudienceSlide,
  persona: PersonaSlide,
  people: PeopleSlide,
  "brand-today": AccountSnapshotSlide,
  community: CommunitySlide,
  snapshot: AccountSnapshotSlide,
  comparison: ComparisonSlide,
  lessons: LessonsSlide,
  map: MapSlide,
  "open-space": OpenSpaceSlide,
  trends: TrendsSlide,
  conversation: ConversationSlide,
  moments: MomentsSlide,
  moment: MomentOnSocialSlide,
  findings: FindingsSlide,
  method: MethodSlide,
  insight: InsightSlide,
  idea: IdeaSlide,
  "idea-posts": IdeaPostsSlide,
  objectives: ObjectivesSlide,
  targets: TargetsSlide,
  platforms: PlatformsSlide,
  pillars: PillarsSlide,
  pillar: PillarSlide,
  mix: MixSlide,
  codes: CodesSlide,
  year: YearSlide,
  rhythm: RhythmSlide,
  creators: CreatorsSlide,
  reading: ReadingSlide,
  tests: TestsSlide,
  how: HowSlide,
  sources: SourcesSlide,
  close: CloseSlide,
};

export function StrategyTemplateSlide({ ctx }: { ctx: TemplateContext }) {
  const Template = TEMPLATES[ctx.slide.template.id];
  return <Template ctx={ctx} />;
}
